<template>
    <div class="section ">
        <b-loading :is-full-page="true" :active.sync="loadingSubs" :can-cancel="true"></b-loading>
        <b-loading :is-full-page="true" :active.sync="loadingProds" :can-cancel="true"></b-loading>
        <div class="columns is-multiline is-centered ">
            <div v-if="this.prods.length || this.subs.length" class="column is-full has-text-centered">
                <h1 class="title">Resultados de la busqueda <span class="text-custom">{{searchedTerm}}</span></h1>
            </div>
            <div class="column is-full has-text-centered m-t-20">
                <div class="tags">
                    <a 
                    v-for="sub in subs" 
                    :key="sub.id"
                    class="tag is-rounded is-medium is-custom"
                    rounded
                    :href="sub.getProdListUrl">{{sub.title}}</a>
                </div>
            </div>
            <div class="column is-full m-t-20">
                <div class="columns is-multiline is-mobile">
                    <div v-if="!this.prods.length && !this.loadingProds" class="column is-full has-text-centered">
                        <b-icon icon="frown" class="sad-icon"></b-icon>
                        <h1 class="title is-size-6 m-t-5">
                            No encontramos ningun producto para la busqueda: {{searchedTerm}}
                        </h1>
                    </div>
                    <div v-for="product in prods" :key="product.id" class="column is-half-mobile is-one-fifth-tablet is-one-quarter-desktop">
                        <a :href="product.getDetailUrl">
                        <div class="card">
                            <div class="card-image has-text-centered">
                                <div class="img-overlay">
                                    <div class="img-overlay-btn">
                                        <b-button
                                        class="is-custom"
                                        rounded>
                                        <b-icon icon="eye" size="is-small"></b-icon>
                                        Ver producto                            
                                        </b-button>
                                    </div>
                                </div>
                                <div v-if="product.status == 'O'" class="tag is-danger is-rounded sale-tag">
                                    Oferta
                                </div>
                                <img :src="product.getImage" alt="prod-card-image">
                            </div>
                            
                            <div class="card-content">
                                <div class="content product-content">
                                    <p class="has-text-weight-semibold">{{product.title}}</p>
                                    <div class="price has-text-centered">
                                        <p style=" text-decoration: line-through; color:#333;" v-if="product.status=='O'">
                                            {{product.currencySymbol}} {{product.compareAt}}
                                        </p>
                                        <p class="has-text-custom">{{product.currencySymbol}} {{product.price}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </a>
                    </div>

                    <div v-if="this.prods.length" class="column is-full">
                        <div class="p-top-30">
                            <b-pagination
                                :total="count"
                                :per-page="perPage"
                                :current.sync="page"
                                :range-before="2"
                                :rounded="true"
                                :range-after="2"
                                order="is-centered"
                                @change="onPageChange"
                                icon-prev="chevron-left"
                                icon-next="chevron-right"
                            >
                            </b-pagination>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getHandler } from '../../../services/http'
export default {
    props:{
        searchedTerm:{
            type:String,
            default:""
        },
        resultsEndpoint:{
            type:String,
            default:""
        },
        prodOnlyEndpoint:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            subs:[],
            loadingSubs:false,

            prods:[],
            loadingProds:false,
            page:1,
            perPage:24,
            count:0
        }
    },
    methods:{
        async fetchSubs(){
            this.loadingSubs = true
            this.subs = await getHandler(this.resultsEndpoint, {error:false, success:false})
            this.loadingSubs = false
        },
        async fetchProds(){
            this.loadingProds = true
            let url = this.prodOnlyEndpoint + `&page=${this.page}&public_only=True`
            var response = await getHandler(url, {error:false, success:false})
            this.loadingProds = false
            this.count = response.count
            this.prods = response.results
        }
    },
    created(){
        this.fetchSubs()
        this.fetchProds()
    }
}
</script>


<style lang="scss" scoped>

.text-custom{
    color: var(--primary);
}

.is-custom{
    color: var(--text-color);
    background: var(--primary);
}


.card{
    height:100%;
    border:0px #fff solid !important;
    box-shadow: 0px 0px 0px 0px #b8b8b8;
    transition: all 1s;
}
a:hover {
    .card{
        box-shadow: 1px 10px 10px #b8b8b8;
        .card-image{
            img{
                transform: scale(1.1);
            }
            .img-overlay{
                opacity: 1;
            }
        }
    }
}
.card-image{
    overflow: hidden;
    img{
        max-height: 200px;
        transition: all 3s;
    }
}
.card-content{
    padding:5px;
}
.product-content{
    margin: 0px;
     p{
        margin:0px;
        padding:0px;
    }
}


.img-overlay{
    position:absolute;
    opacity:0;
    z-index:10;
    width:100%;
    height:100%;
    background: rgba(0, 0, 0, 0.2);
    transition: opacity 0.5s ease-in;
}

.img-overlay-btn{
    position: absolute;
    bottom: 20px;;
    left: 0;
    width: 100%;
}

.is-custom{
    background-color: var(--primary);
    color: var(--text-color);
}

.has-text-custom{
    color: var(--primary)
}

.sale-tag{
    position:absolute;
    left:5px;
    top:5px;
    z-index:10;
}

.sad-icon{
    font-size: 3rem;
    color: var(--primary);
}
</style>